import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { supabase } from '@/integrations/supabase/client';

type Status = 'loading' | 'valid' | 'already' | 'invalid' | 'success' | 'error';

const Unsubscribe = () => {
  const [params] = useSearchParams();
  const token = params.get('token');
  const [status, setStatus] = useState<Status>('loading');

  useEffect(() => {
    if (!token) { setStatus('invalid'); return; }

    const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
    const anonKey = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

    fetch(`${supabaseUrl}/functions/v1/handle-email-unsubscribe?token=${token}`, {
      headers: { apikey: anonKey },
    })
      .then(r => r.json())
      .then(data => {
        if (data.valid === false && data.reason === 'already_unsubscribed') setStatus('already');
        else if (data.valid) setStatus('valid');
        else setStatus('invalid');
      })
      .catch(() => setStatus('invalid'));
  }, [token]);

  const handleUnsubscribe = async () => {
    if (!token) return;
    try {
      const { data } = await supabase.functions.invoke('handle-email-unsubscribe', {
        body: { token },
      });
      if (data?.success) setStatus('success');
      else if (data?.reason === 'already_unsubscribed') setStatus('already');
      else setStatus('error');
    } catch {
      setStatus('error');
    }
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-6">
      <div className="max-w-md w-full text-center space-y-6">
        {status === 'loading' && <p className="text-muted-foreground">Загрузка...</p>}

        {status === 'valid' && (
          <>
            <h1 className="text-2xl font-display font-bold text-foreground">Отписаться от рассылки</h1>
            <p className="text-muted-foreground">Вы уверены, что хотите отписаться?</p>
            <button
              onClick={handleUnsubscribe}
              className="px-8 py-3 bg-primary text-primary-foreground font-display font-bold rounded-full hover:scale-[1.02] transition-transform"
            >
              Подтвердить
            </button>
          </>
        )}

        {status === 'success' && (
          <>
            <h1 className="text-2xl font-display font-bold text-foreground">Готово</h1>
            <p className="text-muted-foreground">Вы успешно отписались от рассылки.</p>
          </>
        )}

        {status === 'already' && (
          <>
            <h1 className="text-2xl font-display font-bold text-foreground">Уже отписаны</h1>
            <p className="text-muted-foreground">Вы уже отписались ранее.</p>
          </>
        )}

        {status === 'invalid' && (
          <>
            <h1 className="text-2xl font-display font-bold text-foreground">Ошибка</h1>
            <p className="text-muted-foreground">Недействительная или истёкшая ссылка.</p>
          </>
        )}

        {status === 'error' && (
          <>
            <h1 className="text-2xl font-display font-bold text-foreground">Ошибка</h1>
            <p className="text-muted-foreground">Не удалось обработать запрос. Попробуйте позже.</p>
          </>
        )}
      </div>
    </div>
  );
};

export default Unsubscribe;
